import * as React from 'react'

import { Box, Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import {
  CompanyEstimateManagerScoreFragment,
  PerformanceSetShowEstimatedScoreDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import performanceWeightsUpsell from 'modules/performance_process/lib/assets/performanceWeightsUpsell.png'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

type Props = {
  companySetting: CompanyEstimateManagerScoreFragment
  hasCustomScoreConfigurationEnabled: boolean
}

export const CompanyEstimateManagerScore: React.FC<Props> = ({
  companySetting,
  hasCustomScoreConfigurationEnabled,
}) => {
  const [localShowEstimatedScore, setLocalShowEstimatedScore] = React.useState(
    companySetting.showEstimatedScore
  )

  const [updateShowEstimatedScore, { loading }] = useMutation(
    PerformanceSetShowEstimatedScoreDocument,
    {
      extractorFn: (data) =>
        data.performanceMutations.setShowEstimatedScorePerformanceCompanySetting,
    }
  )

  const handleChange = async (value: boolean) => {
    const response = await updateShowEstimatedScore({
      variables: {
        id: companySetting.id,
        showEstimatedScore: value,
      },
    })

    const result = handleResult(response, () => {})

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    } else {
      setLocalShowEstimatedScore(!value)
    }
  }

  return (
    <Box gap="s32">
      <Card>
        <Card.Title
          size="medium"
          action={
            <TogglerCheckbox
              value={localShowEstimatedScore}
              onChange={(value) => handleChange(value)}
              disabled={loading || !hasCustomScoreConfigurationEnabled}
              aria-label={i18n.t(
                'performance_process.employee_score.company_settings.dynamic_scoring.toggle_label'
              )}
            />
          }
        >
          {i18n.t(
            'performance_process.employee_score.company_settings.dynamic_scoring.toggle_label'
          )}
        </Card.Title>
        <Card.Description>
          {i18n.t(
            'performance_process.employee_score.company_settings.dynamic_scoring.description'
          )}
        </Card.Description>

        {!hasCustomScoreConfigurationEnabled && (
          <Card.Content>
            <UpsellingKit.ProductWidgetPopover
              label={i18n.t('pricing_plans.generic_upgrade')}
              mediaUrl={performanceWeightsUpsell}
              variant="outlinePromote"
              title={i18n.t('performance_process.upsells.weights.title_banner')}
              description={i18n.t('performance_process.upsells.weights.description')}
              requestSource="Performance - weights enterprise plan - wizard selector"
              moduleRequested={AvailableModules.review_process}
              featureRequested={Features.review_process_custom_score_configuration}
              requestReason={ValidReasons.MissingFeature}
              side="right"
            />
          </Card.Content>
        )}
      </Card>
    </Box>
  )
}
